<button class="btn btn-icon btn-success text-capitalize" type="button" theme>
  <span class="btn-inner--text">{{ label }}</span>
  <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
</button>
